import React from 'react';
import Video from '../../../../static/image/video.png';
import Audio from '../../../../static/image/audio.png';
import {Cell, Toast, Loading} from 'zarm';
import './index.less';
import utils from '@seeing/utils';
import {askSDK} from '@utils/index';
import {
  AudioPlayer, // 音频
  MediaList, // 视频列表
  VideoPalyer,
} from '@wap/components';
class ShowMediaCell extends React.Component {
  static defaultProps = {
    data: [],
    title: '图片和视频',
    sourceType: 65, // 来源  角塑病例笔记附件-68，角塑检查项附件-65
    max: 10,
  };

  constructor(props) {
    super(props);
    this.state = {
      showList: [], // 音视频展示list,
    };
  }

  componentDidMount() {
    this.handleLensParam(this.props.data);
  }

  // 处理sdk返回的音频和视频
  handleLensParam = (record = []) => {
    if (record.length === 0) return;
    const {fileEyeType, mediaType} = this.props;
    const examFiles = record.map((file) => {
      const {fileUrl, fileType, fileHomeUrl, fileTimeLength} = file;
      return {
        ...file,
        sourceURL: +fileType === 4 ? '' : fileUrl,
        sourceImage: +fileType === 4 ? fileUrl : fileHomeUrl,
        duration: file.duration ? file.duration : fileTimeLength,
        fileTimeLength: file.duration ? file.duration : fileTimeLength,
        showDelete: true,
      };
    });

    let showList = [];

    if (+mediaType === 1) {
      // 音频文件
      showList = examFiles.filter(
        (item) => +item.fileType === 2 && item.fileEyeType === +fileEyeType
      );
    } else {
      // 视频和图片
      showList = examFiles.filter(
        (item) =>
          [3, 4].indexOf(+item.fileType) > -1 &&
          item.fileEyeType === +fileEyeType
      );
    }
    this.setState({
      showList,
    });
  };

  // 添加视频或者音频
  onMediaAdd = (file) => {
    const examFiles = utils.copy(this.props.data);
    examFiles.push({...file, fileTimeLength: file.duration});
    this.handleLensParam(examFiles);
    this.props.onSuccess(examFiles);
  };

  // 选择语音或者视频图片 调用sdk
  chooseMedia = async (mediaType, fileEyeType, sourceType) => {
    Loading.show();
    const param = {
      sourceType,
      userId: this.props?.match?.params?.patientId,
    };
    if (!+mediaType) {
      let videoCount = 0;
      // let fileType = 0 // 0-上传图片或者视频 3-视频 4-图片
      let {fileType = 0} = this.props;

      let picCount = 0;
      this.state.showList.forEach((val) => {
        if (val.fileType === 3) {
          //视频统计
          videoCount++;
        }
        if (val.fileType === 4) {
          // 图片统计
          picCount++;
        }
      });
      if (fileType === 0) {
        if (videoCount > 2) {
          fileType = 4;
        }
        if (picCount > 8) {
          fileType = 3;
        }
        if (picCount > 8 && videoCount > 2) {
          Toast.show({
            content: '视频最多添加3个,图片最多添加9个',
            stayTime: 500,
          });
          Loading.hide();
          return;
        }
      }
      if (picCount >= this.props.max) {
        Toast.show({
          content: `图片最多添加${this.props.max}个`,
          stayTime: 500,
        });
        Loading.hide();
        return;
      }
      if (videoCount >= this.props.max) {
        Toast.show({
          content: `视频最多添加${this.props.max}个`,
          stayTime: 500,
        });
        Loading.hide();
        return;
      }
      param.fileType = fileType;

      // 视频和图片
      // 调用保存到本地sdk 后端提供   区分ios和Android
      await askSDK('selectPhotoOrVideo', param, async (res) => {
        const media = JSON.parse(res);
        if (media.result === 1) {
          await this.onMediaAdd({...media, fileEyeType});
          Toast.show({
            content: '添加成功',
            stayTime: 500,
          });
          Loading.hide();
        } else {
          Loading.hide();
        }
      });
    } else {
      if (this.state.showList.length === this.props.max) {
        Toast.show({
          content: `音频最多添加${this.props.max}个`,
          stayTime: 500,
        });
        Loading.hide();
        return;
      }

      // 音频
      await askSDK('selectRecord', param, async (res) => {
        const media = JSON.parse(res);
        if (media.result === 1) {
          await this.onMediaAdd({...media, fileEyeType});
          Toast.show({
            content: '添加成功',
            stayTime: 500,
          });
          Loading.hide();
        } else {
          Loading.hide();
        }
      });
    }
  };
  // 删除音视频
  onDelete = (id) => {
    const {data} = this.props;
    let examFile = utils.copy(data);
    let list = utils.copy(this.state.showList);
    const index = examFile.findIndex((val) => val.fileId === id);
    const showIndex = list.findIndex((val) => val.fileId === id);
    examFile.splice(index, 1);
    list.splice(showIndex, 1);
    this.setState({
      showList: list,
    });
    this.props.onSuccess(examFile);
  };

  render() {
    const {
      mediaType = 0, // 0-视频和图片  1-语音
      title = '图片和视频',
      fileEyeType = 1, //类别 1-od; 2-os
      sourceType = 65, // 来源 角塑病例笔记附件-68，角塑检查项附件-65
      hiddenOther,
    } = this.props;
    const {showList} = this.state;

    // 过滤出图片数组
    const imageList = showList
      .filter((item) => item.fileType === 4)
      .map((item) => item.fileUrl);
    return (
      <>
        {!hiddenOther && <div className="other">{title}</div>}
        <Cell
          icon={
            <img
              alt=""
              onClick={() =>
                this.chooseMedia(mediaType, fileEyeType, sourceType)
              }
              src={+mediaType ? Audio : Video}
              style={{width: '66px', height: '66px'}}
            />
          }
        >
          <div>
            {+mediaType
              ? showList.map((item) => {
                  // 音频
                  return (
                    <AudioPlayer
                      duration={item.duration}
                      key={item.fileId || item.id}
                      gutter={[12, 8]} // 上下间距
                      sourceURL={item.sourceURL}
                      showDelete={item.showDelete} // 是否显示删除按钮
                      onDelete={(e) => this.onDelete(item.fileId)} // 删除事件
                    />
                  );
                })
              : showList.length > 0 && (
                  <MediaList>
                    {showList.map((item) => {
                      // 视频和图片
                      return (
                        <VideoPalyer
                          width={66}
                          height={66}
                          gutter={[8, 6]} // 上下左右间距
                          key={item.fileId || item.id}
                          sourceURL={item.sourceURL}
                          sourceImage={item.sourceImage}
                          sourceList={imageList}
                          showDelete={item.showDelete} // 是否显示删除按钮
                          onDelete={(e) => this.onDelete(item.fileId)} // 删除事件
                        />
                      );
                    })}
                  </MediaList>
                )}
          </div>
        </Cell>
      </>
    );
  }
}

export default ShowMediaCell;
